import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { InventoryTransfers_ModuleContextService } from './InventoryTransfers.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class InventoryTransfers_inventory_transfer_statuses_dd_ComponentContextService {
  private readonly moduleContext: InventoryTransfers_ModuleContextService;

  constructor(moduleContext: InventoryTransfers_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'inventory_transfer_statuses_dd',
      type: ComponentType.selector
    }
  }
}